<template>
	<div>
		<div style="text-align: center;margin: 1rem auto;font-size: 0.58rem;">欢迎下载交道App</div>
		<img style="display: block;margin: 0 auto;" src="../../../assets/logo.png" />
	</div>
	<!-- uniquecode -->
</template>

<script>
import { Notify,Dialog  } from 'vant';
import request from '@/utils/request';
export default {
	components: {
		[Notify.name]: Notify,
		[Dialog.name]: Dialog,
	},
	data() {
		return {
			uniquecode:'',
		};
	},
	created() {
		this.initData();
	},
	mounted() {
		let _this = this;
	},

	methods: {
		initData() {
			let _this = this;
			let id = this.GetQueryString("uniquecode");
			// let url = "Global.env + Global.apiCore.syncStudent "+ "/" + id;
			let url = "https://api.jiaodao11.com/admin/third/syncStudent"+ "/" + id;
			return new Promise((resolve, reject) => {
				request({
					url: url,
					method: 'get', //查询一般为get
				}).then(response => {
					if (response.resultCode == "1000") {
						Dialog.alert({
							message: "下载app后的登录名为注册手机号,密码与注册密码一样",
						}).then(() => {
						});
					}else{
						Notify({ type: 'warning', message: response.resultDesc });
					}
				}).catch(error => {
					return reject(error);
				})
			})
		},
		GetQueryString(name){
		     var reg = new RegExp("(^|&)"+ name +"=([^&]*)(&|$)");
		     var r = window.location.search.substr(1).match(reg);
		     if(r!=null)return  unescape(r[2]); return null;
		}
		
		
	}
};
</script>
<style>
	.van-dialog__message {
	    height: 1.2rem!important;
	    line-height: 0.6rem!important;
	    font-size: .32rem!important;
	}
	
	
</style>
